export class FormUtility {
  // If string is empty, return null otherwise return original value
  public static emptyStringCheck(value: string): string | null {
    return (value && value.length > 0) ? value : null;
  }
}
